const HERO_SPLIT_DESKTOP = 4 / 5;
const HERO_FULL_BLEED_DESKTOP = 16 / 10;
const HERO_MOBILE = 3 / 4;

export const EDITORIAL_MEDIA_FRAME_CONTRACTS = Object.freeze({
  HERO: Object.freeze({
    A: Object.freeze({ desktop: HERO_SPLIT_DESKTOP, mobile: HERO_MOBILE }),
    B: Object.freeze({ desktop: HERO_SPLIT_DESKTOP, mobile: HERO_MOBILE }),
    C: Object.freeze({ desktop: HERO_FULL_BLEED_DESKTOP, mobile: HERO_MOBILE }),
  }),
});

export function editorialMediaFrameAspect(masterType, { mode = "desktop", variant = "A" } = {}) {
  const master = EDITORIAL_MEDIA_FRAME_CONTRACTS[masterType];
  if (!master) return null;
  const composition = master[variant] || master.A;
  return composition?.[mode] ?? composition?.desktop ?? null;
}

export function editorialMediaFrameLabel(masterType, { mode = "desktop", variant = "A" } = {}) {
  if (masterType !== "HERO") return "Кадр публикации";
  if (mode === "mobile") return "Кадр для телефона";
  if (variant === "C") return "Широкий кадр на весь разворот";
  return "Кадр колонки";
}

export function formatEditorialAspect(aspect) {
  if (!Number.isFinite(aspect) || aspect <= 0) return "авто";
  const known = [
    [16 / 10, "16:10"],
    [4 / 5, "4:5"],
    [3 / 4, "3:4"],
  ];
  const hit = known.find(([value]) => Math.abs(value - aspect) < 0.001);
  return hit?.[1] || aspect.toFixed(2);
}
